import { render, staticRenderFns } from "./userCourseDescription.html?vue&type=template&id=5b53642d&"
import script from "./userCourseDescription.js?vue&type=script&lang=js&"
export * from "./userCourseDescription.js?vue&type=script&lang=js&"
import style0 from "./userCourseDescription.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports